import { fromJS } from 'immutable';
import * as constants from '../messaging-constants';
import R from 'ramda';

const initialMsgsState = fromJS({
  list: [],
  loadingMessages: false,
});

export default (state = initialMsgsState, { type, payload }) => {
  switch (type) {
    case 'UPDATE_PROPS_IN_MESSAGING_MESSAGES':
      return state.merge(fromJS(payload));
    case constants.LOADING_MSGS:
      return state.set('loadingMessages', payload)
        .set('messagesLoaded', !payload);
    case constants.MSGS_LOADED_INITIALLY:
      return state.merge(fromJS({
        conv: payload.conv,
        list: payload.messages,
        lastMsgId: payload.lastMsgId,
        messagesLoaded: true,
        loadingMessages: false,
      }));
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/app/components/messaging/messagingStore/reducers/msgs-reducer.js